module.exports = __webpack_public_path__ + "static/media/team-pose.1cf963c6.png";